import { useEffect, useState } from "react";
import { horaLocal, naJanelaDaDisputa, retratoDoDia } from "@nhomi/core";
import { cutucar } from "@/data/disputa";
import type { Member } from "@/data/members";
import { Avatar } from "@/ui/primitives";

/* ============================================================
   "Ainda não postaram hoje" — e o botão de cutucar

   Só à noite (18h–22h, a mesma janela dos avisos) e só quando faltam
   poucos ativos (1 a 3): com metade do grupo faltando, cutucar vira
   spam. O servidor confere tudo de novo — uma cutucada por pessoa por
   dia, venha de quem vier, e quem foi bloqueado cutuca no vazio.
   ============================================================ */

const FUSO = "America/Sao_Paulo";

export function Cutucar(
  { cid, eu, membros, hoje, bloqueados }: {
    cid: string; eu: string; membros: Member[]; hoje: string; bloqueados: Set<string>;
  },
) {
  const [hora, setHora] = useState(() => horaLocal(new Date(), FUSO));
  const [estado, setEstado] = useState<Record<string, "indo" | "feito" | string>>({});
  useEffect(() => {
    const t = setInterval(() => setHora(horaLocal(new Date(), FUSO)), 60_000);
    return () => clearInterval(t);
  }, []);

  if (!naJanelaDaDisputa(hora)) return null;
  const { ativos, faltam } = retratoDoDia(membros, hoje);
  if (ativos.length < 2 || faltam.length < 1 || faltam.length > 3) return null;
  const outros = faltam.filter((m) => m.uid !== eu && !bloqueados.has(m.uid));
  if (!outros.length) return null;

  return (
    <div className="pad">
      <div className="card cutucar">
        <div className="cutucar-t">
          {faltam.length === 1 ? "Só falta uma pessoa hoje" : `Faltam ${faltam.length} hoje`}
        </div>
        {outros.map((m) => {
          const s = estado[m.uid];
          return (
            <div key={m.uid} className="cutucar-linha">
              <Avatar name={m.name} photo={(m as Member).photo} size="sm" />
              <span className="cutucar-nome">{m.name.split(" ")[0]}</span>
              {s && s !== "indo" && s !== "feito" ? <span className="cutucar-erro">{s}</span> : null}
              <button className="btn btn-mini" disabled={!!s}
                onClick={async () => {
                  setEstado((e) => ({ ...e, [m.uid]: "indo" }));
                  try {
                    await cutucar(cid, m.uid);
                    setEstado((e) => ({ ...e, [m.uid]: "feito" }));
                  } catch (err) {
                    setEstado((e) => ({ ...e, [m.uid]: (err as { message?: string }).message || "Não deu agora." }));
                  }
                }}>
                {s === "feito" ? "Cutucado 👉" : s === "indo" ? "…" : "Cutucar"}
              </button>
            </div>
          );
        })}
      </div>
    </div>
  );
}
